<template>
  <MainLayout page-name="landing-passengers-data">
    <PageHeader :title="title">
      <el-row class="header-button">
        <!-- 新規取込追加 -->
        <el-col>
          <el-button type="primary" class="import" @click="clickImport">新規取込</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="register" @click="clickRegister">新規追加</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="search" :required="true" />
        <BillToCode v-model="simpleSearchFormModel.bill_to_code" :searchCond="true" :autocomplete-list="customerCodeSet" :initialize="true" :disabled="decisionDisabled()"/>
        <AirportCode v-model="simpleSearchFormModel.departure_airport_code" label="出発地"
          prop="departure_airport_code" :searchCond="true" :autocomplete-list="airportCodeSet" :initialize="true" />
        <AircraftWeightType v-model="simpleSearchFormModel.aircraft_weight_type" label="" placeholder="機種重量区分" :searchCond="true" :initialize="true" />
      </SimpleSearch>
    </PageHeader>
    <Table
      :multiSelect="true"
      :table-data="tableData"
      :default-sort="{ prop: 'bill_to_code', order: 'ascending' }"
      :selectable="deletable"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <BillingYmColumn :sortable="true" />
        <BillToCodeColumn label="請求先" :sortable="true" />
        <AirportCodeColumn label="出発地" prop="departure_airport_code" :sortable="true" />
        <PaidFlightsColumn :sortable="true" />
        <SeatsColumn :sortable="true" />
        <PaidPassengersColumn :sortable="true" />
        <AircraftWeightTypeNameColumn :sortable="true" />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" /> -->
        <BillingYmColumn />
        <BillToCodeColumn label="請求先" />
        <AirportCodeColumn label="出発地" prop="departure_airport_code" />
        <PaidFlightsColumn />
        <SeatsColumn />
        <PaidPassengersColumn />
        <AircraftWeightTypeNameColumn />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" />
      </template>
    </Table>
    <LandingPassengersDataRegisterDialog
      :visible.sync="registerDialogVisible"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <LandingPassengersDataEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
    <!-- 新規取込追加 -->
    <LandingPassengersDataImportDialog
      :visible.sync="importDialogVisible"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import AircraftWeightType from '@/components/molecules/form/select/AircraftWeightType.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import BillToCodeColumn from '@/components/molecules/table/BillToCodeColumn.vue'
import AirportCodeColumn from '@/components/molecules/table/AirportCodeColumn.vue'
import PaidFlightsColumn from '@/components/molecules/table/PaidFlightsColumn.vue'
import SeatsColumn from '@/components/molecules/table/SeatsColumn.vue'
import PaidPassengersColumn from '@/components/molecules/table/PaidPassengersColumn.vue'
import AircraftWeightTypeNameColumn from '@/components/molecules/table/AircraftWeightTypeNameColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import LandingPassengersDataRegisterDialog from '@/components/pages/data/landingPassengersData/LandingPassengersDataRegisterDialog.vue'
import LandingPassengersDataEditDialog from '@/components/pages/data/landingPassengersData/LandingPassengersDataEditDialog.vue'
// 新規取込追加
import LandingPassengersDataImportDialog from '@/components/pages/data/landingPassengersData/LandingPassengersDataImportDialog.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    BillingYm,
    BillToCode,
    AirportCode,
    AircraftWeightType,
    SimpleSearch,
    Table,
    BillToCodeColumn,
    AirportCodeColumn,
    PaidFlightsColumn,
    SeatsColumn,
    PaidPassengersColumn,
    AircraftWeightTypeNameColumn,
    BlankColumn,
    MenuColumn,
    LandingPassengersDataRegisterDialog,
    LandingPassengersDataEditDialog,
    // 新規取込追加
    LandingPassengersDataImportDialog
  },
  mixins: [
    AirportAutocompleteLoader,
    CustomerAutocompleteLoader
  ],
  data () {
    return {
      title: '着陸時有償旅客データ',
      tableData: [],
      simpleSearchFormModel: {
        billing_ym: this.getDefaultBillingYm(),
        bill_to_code: '',
        departure_airport_code: '',
        aircraft_weight_type: ''
      },
      currentRow: {},
      importDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('landingPassengersDataSearchCond')
    this.loadAirport()
    this.loadCustomer()
  },
  methods: {
    decisionDisabled () {
      var result = false
      if (this.$loginuser.get('role_id').indexOf('airline') !== -1) {
        result = true
        this.simpleSearchFormModel.bill_to_code = this.$loginuser.get('customer_code')
      }
      return result
    },
    clickImport () {
      this.importDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('landingPassengersDataSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('landingPassengersDataSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('landingPassengersDataSearchCond'))
      this.$axios
        .get('/search-landing-passengers-data', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (billingYm) {
      const searchCond = JSON.parse(sessionStorage.getItem('landingPassengersDataSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'billing_ym', billingYm)
        sessionStorage.setItem('landingPassengersDataSearchCond', JSON.stringify(this.simpleSearchFormModel))
      }

      this.search()
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      const currentRow = { ...row }
      if (parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm())) {
        currentRow.billing_ym = ''
      }
      this.currentRow = currentRow
      this.registerDialogVisible = true
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/landing-passengers-data', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    },
    deletable (row, index) {
      // 削除可能条件
      return !(parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm()))
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
th.billing-ym{
  display: none;
}
td.billing-ym{
  display: none;
}
</style>
